<template>
  <div class="settings d-flex flex-column justify-content-center card">
    <h1 class="title">{{ $t("settings.title") }}</h1>
    <div class="p-2">
      <div class="tomatos d-flex justify-content-center">
        <label>{{ $t("settings.redness")}}</label>
        <div class="p-2">
          <i
            class="material-icons arrows"
            v-show="this.selectedTomato != 1"
            @click="before()"
          >navigate_before</i>
          <img
            class="video"
            width="33%"
            :src="require(`@/assets/tomatos/stage${this.selectedTomato || 1}.png`)"
          />
          <i
            class="material-icons arrows"
            v-show="this.selectedTomato != 6"
            @click="next()"
          >navigate_next</i>
        </div>
      </div>
    </div>
    <div class="p-2">
      <div class="row">
        <div class="col">
          <label for="perBox">{{ $t("settings.tomatos_per_box")}}</label>
        </div>
        <div class="col">
          <input
            type="number"
            min="1"
            max="100"
            id="perBox"
            class="form-control"
            :value="tomatoesPerBox"
            @input="updateTomatoesPerBox"
          />
        </div>
      </div>
    </div>
    <div class="p-2">
      <div class="row">
        <div class="col">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="confirmationCheck"
              :checked="confirmationRequired"
              @change="updateConfirmationRequired"
            />
            <label
              class="form-check-label"
              for="confirmationCheck"
            >{{ $t("settings.ask_for_confirmation")}}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="p-4 close-button">
        <a @click.prevent="goBack()" class="btn btn-primary center">{{ $t("global.close")}}</a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";

export default {
  name: "Settings",
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState({
      selectedTomato: state => state.selectedTomato,
      confirmationRequired: state => state.confirmationRequired,
      tomatoesPerBox: state => state.tomatoesPerBox
    })
  },
  methods: {
    before() {
      if (this.selectedTomato > 1) {
        this.$store.dispatch("selectedTomato", this.selectedTomato - 1);
      }
    },
    next() {
      if (this.selectedTomato < 6) {
        this.$store.dispatch("selectedTomato", this.selectedTomato + 1);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    updateTomatoesPerBox(e) {
      this.$store.dispatch("tomatoesPerBox", e.target.value);
    },
    updateConfirmationRequired(e) {
      this.$store.dispatch("confirmationRequired", e.target.checked);
    }
  }
};
</script>

<style scoped>
.title {
  margin-top: 20px;
  text-align: center;
  font-size: 30px;
}
.close-button {
  margin-top: 20px;
  text-align: center;
}
.arrows {
  font-size: 50px;
}
.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03),
    0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03),
    0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05),
    0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
  border-width: 0;
  transition: all 0.2s;
}
</style>